class HSLA {
    constructor(H, S, L, A = 1) {
        this.H = H;
        this.S = Math.min(S, 100);
        this.L = Math.min(L, 100);
        this.A = A;
    }

    toString() {
        return `hsla(${this.H},${this.S}%,${this.L}%,${this.A})`;
    }

    getShade(nr, difference = 20) {
        if (nr == 0)
            return this;
        if (nr % 2 == 0) {
            return new HSLA(this.H, this.S + (difference) / Math.pow(2, nr / 2), this.L + (difference) / Math.pow(2, nr / 2), this.A);
        } else {
            return new HSLA(this.H, this.S - (difference) / Math.pow(2, (nr + 1) / 2), this.L - (difference) / Math.pow(2, (nr + 1) / 2), this.A);
        }
    }
}

export { HSLA };